import { CellClickedEvent, ColDef } from "ag-grid-community";
import { useMemo } from "react";
import type { FhirSectionProps } from "../fhir-section";
import FhirSection from "../fhir-section";
import { createReportsFilterToggles } from "./filter-utils";

function ReportsSection(props: FhirSectionProps) {
  const defaultColDef: ColDef = {
    flex: 1,
    onCellClicked: (event: CellClickedEvent) => props.handleCellClick(props.sectionId, event),
    cellStyle: props.handleCellStyle,
  };

  const filterToggles = useMemo(() => {
    return createReportsFilterToggles(props.rowData);
  }, [props.rowData]);

  return <FhirSection {...props} defaultColDef={defaultColDef} filterToggles={filterToggles} />;
}

export default ReportsSection;
